var XPortal = XPortal || {};
XPortal.ExTextEditor = (function () {
    var self = {
        ControlSelector: ".form-extext-input",
        Init: function (selector) {
            var container = $(selector ? selector : ".detail-page");
            container.find(XPortal.ExTextEditor.ControlSelector).each(function (i, element) {
                XPortal.ExTextEditor.initFor($(element), XPortal.Store.getModelName(container[0].id));
            });
        },
        initFor: function (el, modelName) {
            const sttgs = XPortal.Main.GetSettingsFor(el);
            sttgs.mask = el.attr("data-metadata-mask");
            sttgs.ishtml = el.attr("data-metadata-ishtml") == "1";
            sttgs.ismline = el.attr("data-metadata-ismline");
            sttgs.tools = sttgs.editable ? self.defaultTools : self.readOnlyDefaultTools;
            sttgs.change = sttgs.keyup;
            sttgs.past = sttgs.keyup;
            sttgs.value = sttgs.value ? sttgs.value : el.val();
            var xinterval = 0;
            sttgs.keyup = function () {
                clearTimeout(xinterval);
                xinterval = setTimeout(function () {
                    el.trigger("change");
                }, 250);
            };

            var isDark = $('body').hasClass('theme-dark');

            var pathToStyle = isDark ? "/content/css/dist/texteditorDark.css" : "/content/css/dist/texteditor.css"

            sttgs.stylesheets = [
                pathToStyle
            ];
            if (sttgs.ishtml) {
                var disabled = sttgs.editable ? '' : 'disabled';

                el.wrap(`<div class="kendoo-html-editor form-control p-0 ${disabled}"></div>`);
                el.kendoEditor(sttgs);
                var keditor = el.data("kendoEditor");
                if (!sttgs.editable) {
                    var ebody = $(keditor.body);
                    var bhtmlelements = [el, ebody,];
                    el.closest(".kendoo-html-editor").find("table, th, td, iframe").each(function (ixel, xel) { bhtmlelements.push(xel); });
                    $.each(bhtmlelements, function (ixel, xel) {
                        $(xel).attr("style", "background:transparent!important");
                    });
                    ebody.removeAttr("contenteditable").find("a").on("click.readonly", false);
                }
                var changehandler = function (e) {
                    //view html button change issue- it doesn't trigger change in main/linked control
                    el.chageEventIndexId = setTimeout(function () {
                        el.trigger("change");
                    })
                }
                keditor.unbind("change", changehandler);
                keditor.bind("change", changehandler);

                // Fit the editor into the remaining height of section-content (when nested in one)
                self.fitToSection(el.closest(".kendoo-html-editor"));
            }
            else if (sttgs.mask) self.initMask(el, sttgs);
            el.off("change");
            el.off("command");
            el.on("change", function () {
                clearTimeout(el.chageEventIndexId);
                var xvalue = getElementValue(el, sttgs);
                XPortal.DefaultEditor.SetModification(el, xvalue);
                XPortal.Store.FieldEvent(el, xvalue, modelName, sttgs);
            });

            if (el) {
                var picker = el.data("kendoMaskedTextBox");
                $((picker ? picker.element : null) || el).attr("data-skip", "");
            }

            if (sttgs.fieldname && modelName) {
                XPortal.Store.Subscribe({ Model: modelName, Field: sttgs.fieldname, Target: el },
                    (value) => {
                        var cval = getElementValue(el, sttgs);
                        if (XPortal.DefaultEditor.IsModified(el, cval)) return;
                        setElementValue(el, sttgs, value);
                    },
                    (value) => getElementValue(el, sttgs, false)
                );
            }

        },
        
        fitToSection: function (wrapper, naturalize) {
            if (!wrapper || !wrapper.length) return;
            var wrapEl = wrapper[0];
            if (!wrapEl.closest(".xsection")) return; // editor is not inside a section
            var host = wrapEl.closest(".section-content");
            if (!host) return;

            if (naturalize) wrapper.data("xfitNatural", naturalize);

            // The classic Kendo editor renders as a <table>: let the editable area
            // consume whatever height we hand to the wrapper.
            var stretchInner = function () {
                wrapper.children("table.k-editor").css("height", "100%");
                wrapper.find(".k-editable-area").css("height", "100%");
                wrapper.find(".k-editable-area > .k-content").css("height", "100%");
            };
            // Harmless while the wrapper height is auto (a % height resolves to
            // auto), so set once - unless the natural height is content-driven,
            // where it would overwrite the height the content asked for.
            if (!wrapper.data("xfitNatural")) stretchInner();

            // Sum of margins / paddings / borders sitting below the editor on the
            // way up to .section-content. This space must stay free, otherwise the
            // editor overshoots the section by exactly this amount -> scrollbar.
            var spaceBelow = function () {
                var total = 0, node = wrapEl, cs, p, pcs;
                while (node && node !== host) {
                    cs = getComputedStyle(node);
                    total += parseFloat(cs.marginBottom) || 0;
                    p = node.parentElement;
                    if (p && p !== host) {
                        pcs = getComputedStyle(p);
                        total += (parseFloat(pcs.paddingBottom) || 0)
                            + (parseFloat(pcs.borderBottomWidth) || 0);
                    }
                    node = p;
                }
                return total;
            };

            var applying = false;
            var fit = function () {
                if (applying) return; // ignore re-entrant / self-induced calls
                applying = true;
                try {
                    // Border-box keeps the height math independent of the wrapper's
                    // own border; reset to natural so the free space below is exact.
                    wrapEl.style.boxSizing = "border-box";
                    wrapEl.style.height = "";
                    var natural = wrapper.data("xfitNatural");
                    if (natural) natural();
                    var hcs = getComputedStyle(host);
                    var hostBottom = host.getBoundingClientRect().bottom
                        - (parseFloat(hcs.paddingBottom) || 0)
                        - (parseFloat(hcs.borderBottomWidth) || 0);
                    var rect = wrapEl.getBoundingClientRect();
                    var free = Math.floor(hostBottom - rect.bottom - spaceBelow());
                    // Grow into the spare height only when the section actually
                    // reserves it (full-height layouts). When the section hugs its
                    // content there is none (free ~ 0) -> keep the natural height.
                    if (free > 1) {
                        wrapEl.style.height = (rect.height + free) + "px";
                        stretchInner(); // hand the gained height down to the iframe
                    }
                } finally {
                    applying = false;
                }
            };

            fit();
            // run once more on the next tick, after the editor iframe has laid out
            setTimeout(fit, 0);

            // tear down a previous observer in case of re-initialization
            var prevRo = wrapper.data("xfitObserver");
            if (prevRo) prevRo.disconnect();

            // React to runtime height changes of the section (expand/collapse,
            // window/layout resize...). Filling the editor exactly does not change
            // the host's own box, so the observer is not re-triggered by our writes.
            if (window.ResizeObserver) {
                var ro = new ResizeObserver(fit);
                ro.observe(host);
                wrapper.data("xfitObserver", ro);
            }
        },
        initMask: function (el, o) {
            o.maskOpt = { rules: {}, mask: o.mask };
            var rxp = new RegExp("\{r\:([^}]*)\}");
            var erls = [{ n: '!' }, { n: '@' }, { n: '$' }, { n: '%' }, { n: '|' }, { n: '`' }];
            var k = 0;
            var mr = false;
            var initMaskRule = function (ik) {
                var ikrexp = erls[ik].r;
                return function (c) {
                    return ikrexp.exec(c);
                };
            };
            while (k < erls.length && (mr = rxp.exec(o.mask)) && mr.length > 1) {
                o.mask = o.mask.split(mr[0]).join(erls[k].n);
                erls[k].r = new RegExp(mr[1]);
                o.maskOpt.rules[erls[k].n] = initMaskRule(k);
                k++;
            };
            o.maskOpt.mask = o.mask;
            el.kendoMaskedTextBox(o.maskOpt);
        }
    };
    self.defaultTools = [
        "bold",
        "italic",
        "underline",
        //"strikethrough",
        "justifyLeft",
        "justifyCenter",
        "justifyRight",
        //"justifyFull",
        "insertUnorderedList",
        "insertOrderedList",
        //"indent",
        //"outdent",
        "createLink",
        "unlink",
        "insertImage",
        //"insertFile",
        "subscript",
        "superscript",
        "tableWizard",
        "createTable",
        "addRowAbove",
        "addRowBelow",
        "addColumnLeft",
        "addColumnRight",
        "deleteRow",
        "deleteColumn",
        "viewHtml",
        //"formatting",
        "cleanFormatting"
        //"fontName",
        //"fontSize",
        //"foreColor",
        //"backColor",
        //"print"
    ];
    self.readOnlyDefaultTools = [];
    function getElementValue(el, sttgs, defValue) {
        if (!el) return defValue;
        var r =
            sttgs.ishtml ? el.data("kendoEditor").value() :
                sttgs.mask ? el.data("kendoMaskedTextBox").value() :
                    el.val()
        return r;
    }
    function setElementValue(el, sttgs, valueToSet) {
        XPortal.DefaultEditor.ClearModification(el);
        el.val(valueToSet);
        var editor = el.data("kendoEditor");
        editor = editor || el.data("kendoMaskedTextBox");
        if (editor) editor.value(valueToSet);
    }
    return self;
}());